/**
 * Check if a GIS service layer is loaded and contains sublayers; loop through the sublayers
 * recursively and set the layer's visible property to true.
 * @param {*} layer - Map layer object
 */
const checkLayerVisiblity = layer => {
  if (layer?.loaded && layer?.sublayers?.items?.length) {
    layer.sublayers.items.forEach(async sublayer => {
      if (sublayer?.loaded) {
        setLayerVisible(sublayer);
      } else {
        await sublayer.load();

        if (sublayer?.loaded) {
          setLayerVisible(sublayer);
        }
      }
    });
  }

  return layer;
};

/**
 * Set the GIS service layer's visible property to true.
 * @param {*} layer - Map layer object
 */
const setLayerVisible = layer => {
  if (layer?.visible === false) {
    layer.visible = true;
  }

  if (layer?.sublayers?.items?.length) {
    checkLayerVisiblity(layer);
  }

  return layer;
};

export default checkLayerVisiblity;
